var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.08789 10.4102C7.00586 10.4102 6.92839 10.3942 6.85547 10.3623C6.78255 10.3305 6.72331 10.2872 6.67773 10.2325L3.17773 6.73488C3.12305 6.68934 3.07975 6.63013 3.04785 6.55727C3.01595 6.4844 3 6.40698 3 6.325C3 6.16105 3.05697 6.02214 3.1709 5.90829C3.28483 5.79443 3.42383 5.7375 3.58789 5.7375C3.66992 5.7375 3.74512 5.75344 3.81348 5.78532C3.88184 5.8172 3.94336 5.86047 3.99805 5.91512L7.08789 9.00289L10.1777 5.91512C10.2324 5.86047 10.2939 5.8172 10.3623 5.78532C10.4307 5.75344 10.5059 5.7375 10.5879 5.7375C10.752 5.7375 10.891 5.79443 11.0049 5.90829C11.1188 6.02214 11.1758 6.16105 11.1758 6.325C11.1758 6.40698 11.1598 6.4844 11.1279 6.55727C11.096 6.63013 11.0527 6.68934 10.998 6.73488L7.49805 10.2325C7.45247 10.2872 7.39323 10.3305 7.32031 10.3623C7.2474 10.3942 7.16992 10.4102 7.08789 10.4102Z",
    fill: "#464E5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDropdown);
export default __webpack_public_path__ + "static/media/ic-dropdown.b8a072b3e3f25f2e26567a929a09103f.svg";
export { ForwardRef as ReactComponent };